import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-simple-comment-info',
  templateUrl: './simple-comment-info.component.html',
})
export class SimpleCommentInfoComponent {
  @Input() title: string;
  @Input() description: string;
}
